import { render, staticRenderFns } from "./table-cell-document.vue?vue&type=template&id=28137cd2&scoped=true&"
import script from "./table-cell-document.vue?vue&type=script&lang=js&"
export * from "./table-cell-document.vue?vue&type=script&lang=js&"
import style0 from "./table-cell-document.vue?vue&type=style&index=0&id=28137cd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28137cd2",
  null
  
)

export default component.exports